<template>
	<div class="webview-pet-walking">
		<sorry-page v-if="isError" @reload="getData" class="webview-pet-walking__inner" />
		<div v-else-if="isMount" class="webview-pet-walking__inner">
			<pet-walking-report :petId="petId" />
		</div>
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA } from '../store/modules/common/mutation-types'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'

// Compornents
import PetWalkingReport from '@/components/Organisms/PetWalkingReport'
import SorryPage from '@/views/SorryPage'

export default {
	name: 'WebviewPetWalking',
	components: {
		PetWalkingReport,
		SorryPage
	},
	data () {
		return {
			isError: false,
			isMount: false,
			userId: null,
			userToken: null,
			petId: null
		}
	},
	created () {
		// OnsenUIのbody要素に付与されているstyleを打ち消す
		const style = document.body.getAttribute('style')
		document.body.setAttribute('style', `${style} position: inherit; overflow: auto;`)

		// storeにwebviewフラグを立てる
		this.SET_IS_WEBVIEW(true)
		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		this.petId = this.$route.query.pet_id ? this.$route.query.pet_id.toString() : ''
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', state)
			this.isError = true
		} else if (this.petId === '') {
			// ペットIDエラー
			console.log('petId error: ', this.petId)
			this.isError = true
		} else {
			// URLパラメータからユーザーID、ユーザートークンを取得する
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// APIリクエスト処理
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userData'])
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA]),

		// データ取得処理
		getData () {
			// 状態の初期化
			this.isError = false
			this.isMount = false

			// NOTE: ユーザー情報の取得
			this.SET_USER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			}).then(res => {
				console.log('userData: ', this.userData)
				if (!this.userData) {
					this.isError = true
				} else {
					this.isMount = true
				}
			}).catch(error => {
				// ユーザー情報取得エラー
				console.log('userData error: ', error)
				this.isError = true
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/variable";

.webview-pet-walking {
	width: 100%;
	height: auto;
	background-color: $background-primary;
}
</style>
